module.exports = __webpack_public_path__ + "static/media/our-courses-img-2.ea33d625.jpg";